<template>
    <div class="home">
        <Carousel :slides="bannerData.list" :isShowIndicators="false" class="home-banner">
            <template #slide="{ slide }">
                <img :src="slide.file_url" class="home-banner">
            </template>
        </Carousel>
        <div class="container">
            <!-- <div class="home-countdown">
                <div class="countdown">
                    <div class="countdown-time">
                        <div class="countdown-time__item">
                            <div class="countdown-time__top">{{ countdownDate.days }}</div>
                            <div class="countdown-time__bottom">{{ lang.day }}</div>
                        </div>
                        <div class="countdown-time__item">
                            <div class="countdown-time__top">{{ countdownDate.hours }}</div>
                            <div class="countdown-time__bottom">{{ lang.hour }}</div>
                        </div>
                        <div class="countdown-time__item">
                            <div class="countdown-time__top">{{ countdownDate.minutes }}</div>
                            <div class="countdown-time__bottom">{{ lang.minute }}</div>
                        </div>
                        <div class="countdown-time__item">
                            <div class="countdown-time__top">{{ countdownDate.seconds }}</div>
                            <div class="countdown-time__bottom">{{ lang.second }}</div>
                        </div>
                    </div>
                    <p class="countdown-time__bottom">{{ lang.ago }}</p>
                </div>
            </div> -->

            <div class="home-section">
                <SectionCard :item="item" v-for="(item, index) in sectionList" :key="index" />
            </div>
            <div class="home-video">
                <video src="http://test-data.hkautoexpo.com/res/hkautoexpo_video_2026.mp4" controls autoplay muted playsinline webkit-playsinline loop></video>
            </div>


            <div class="home-news">
                <div class="home-news__news">
                    <div class="home-news__news__title">{{ lang.exhibitionTitle }}</div>
                    <div class="home-news__news__desc" @click="toPage('/news')">
                        <div>{{ lang.exhibitionSummary }}</div>
                        <div class="more">{{ lang.exhibitionMore }}
                            <img src="@assets/home/icon_more.png" srcset="@assets/home/icon_more@2x.png 2x" />
                        </div>
                    </div>
                    <div class="home-news__news__grid">
                        <NewCard v-for="(item, index) in newsList" :key="index" :item="item" />
                    </div>
                </div>
            </div>

            <div class="home-news">
                <div class="home-news__news">
                    <div class="home-news__news__title">
                        {{ oldListTitle }}
                        <div class="page-btns" v-if="oldList.length > 3">
                            <img src="@assets/home/icon_left.png" srcset="@assets/home/icon_left@2x.png 2x"
                                @click="setPage(oldPagination.page - 1)" />
                            <img src="@assets/home/icon_right.png" srcset="@assets/home/icon_right@2x.png 2x"
                                @click="setPage(oldPagination.page + 1)" />
                        </div>
                    </div>
                    <div class="home-news__news__grid">
                        <NewCard v-for="(item, index) in oldShowList" :key="index" :item="item" />
                    </div>
                </div>
            </div>

            <div class="home-brands">
                <div class="brand" v-for="(item, index) in brandList" :key="index">
                    <div class="brand-title">{{ item.title }}</div>
                    <div class="brand-logo">
                        <div class="brand-logo__item"><img :src="item.image_url"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import Carousel from '@/components/carousel/index.vue'
import SectionCard from './components/sectionCard.vue';
import NewCard from './components/newCard.vue';
import { ArticleListAPI, ConfigGetAPI, BannerListAPI } from '@/api/common.js';
import { useRouter } from 'vue-router'
const router = useRouter()

// 语言包
const language = localStorage.getItem("language") || "zh"
const lang = ref({})
import(`@/language/${language}.js`).then(data => {
    lang.value = data.default.home
    console.log(lang.value)
})

// banner参数
const bannerParam = ref({ page_type: "home", position: "banner", page: 1, page_size: 10 })

// banner数据
const bannerData = ref({})

// banner获取
const getBannerList = () => {
    BannerListAPI(bannerParam.value).then(res => {
        bannerData.value = res
    });
}

// 服务卡片参数 
const sectionParam = ref({ name: "home_section_blocks" })

// 服务卡片数据
const sectionList = ref([])

// 服务卡片获取
const getSection = () => {
    ConfigGetAPI(sectionParam.value).then(res => {
        sectionList.value = res.list
        sectionList.value[0].icon = "shop"
        sectionList.value[0].bgcolor = "#059669"
        sectionList.value[1].icon = "media"
        sectionList.value[1].bgcolor = "#6366F1"
        sectionList.value[2].icon = "tickets"
        sectionList.value[2].bgcolor = "#F97316"
    });
}

// 博覽會要聞参数
const articleParam = ref({
    category: "news", // 可选
    page: 1,
    page_size: 3,
    home_order: 1,
    page_position: "home_important", // 首页要闻
})

// 博覽會要聞列表
const newsList = ref([]);

// 获取博覽會要聞
const getNewsList = () => {
    ArticleListAPI(articleParam.value).then(res => {
        newsList.value = res.list
    });
}

// 往期回顾列表
const oldList = ref([])
const oldListTitle = ref('')
const oldShowList = ref([])
// 往期回顾页数信息
const oldPagination = ref({
    page: 1,
    total: 0,
    total_pages: 0

})
// 往期回顾参数
const oldParam = ref({ name: "home_review" })

// 往期回顾翻页
const setPage = (page) => {
    page <= 0 ? page = oldPagination.value.total_pages : page
    page > oldPagination.value.total_pages ? page = 1 : page
    oldPagination.value.page = page
    oldShowList.value = oldList.value.slice((oldPagination.value.page - 1) * 3, (oldPagination.value.page - 1) * 3 + 3)
    console.log('页数', oldPagination.value.page)
}

// 往期回顾
const getOldList = () => {
    ConfigGetAPI(oldParam.value).then(res => {
        oldList.value = res.list
        oldListTitle.value = res.title
        oldPagination.value.total_pages = Math.ceil(oldList.value.length / 3)
        oldShowList.value = oldList.value.slice(0, 3)
    });
}

// 合作商参数
const brandParam = ref({
    name: "home_parnter",
})

// 合作商列表
const brandList = ref([])

// 合作商获取
const getBrands = () => {
    ConfigGetAPI(brandParam.value).then(res => {
        brandList.value = res.list
    });
}

// 跳转到
const toPage = (path) => {
    router.push(path)
}


onMounted(() => {
    getBannerList()
    getSection()
    getNewsList()
    getOldList()
    getBrands()


    // 使用示例：未来日期为2026/06/12 00:00:00
    countdown("2026/06/18 09:00:00");
});

// 倒计时显示数据
const countdownDate = ref({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
})
// 倒计时函数
const countdown = (targetDate) => {
    // 定时更新倒计时
    const interval = setInterval(() => {
        // 获取当前时间
        const now = new Date();
        // 设置未来时间
        const future = new Date(targetDate);
        // 确保未来时间大于当前时间
        if (future <= now) {
            console.log("请输入一个未来的日期和时间");
            return;
        }

        const distance = future.getTime() - now.getTime();
        if (distance < 0) {
            clearInterval(interval);
            console.log("倒计时结束！");
            return;
        }
        // 计算天、小时、分钟和秒
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        countdownDate.value = {
            days,
            hours: hours < 10 ? "0" + hours : hours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds
        }

        // 显示倒计时
        // console.log(`剩余时间：${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`);
    }, 1000); // 每秒更新一次
}

</script>

<style lang="scss">
.home {
    &-banner {
        width: 100%;
        min-width: 1200px;
        max-height: 1093px;
        height: auto;
        position: relative;
        z-index: -1;
    }

    &-countdown {
        max-width: 1200px;
        margin: 0 auto;
        margin-top: -400px;
        height: 202px;

        .countdown {
            background-color: rgba(0, 0, 0, 0.5);
            color: white;
            width: 637px;
            border-radius: 30px;
            text-align: center;
            padding: 20px;
            box-sizing: border-box;
            border-width: 1px;
            border-color: #FFFFFF;
            border-image: linear-gradient(180deg, rgba(255, 255, 255, 0.74) 0%, rgba(248, 248, 248, 0.26) 99.91%);

            &-time {
                display: flex;
                justify-content: space-around;
                align-items: center;

                &__item {
                    width: 24%;
                }

                &__top {
                    font-family: 'D-DINExp-Bold';
                    color: #FFFFFF;
                    font-weight: 700;
                    font-size: 60px;
                    letter-spacing: 5px;
                    line-height: 65px;
                }

                &__bottom {
                    color: #FFFFFF;
                    font-weight: 400;
                    font-size: 26px;
                    margin-top: 24px;
                    line-height: 37px;
                    margin-bottom: 12px;
                }
            }
        }
    }

    &-section {
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: -140px auto 80px auto;
    }

    &-video {
        width: 1200px;
        height: 674px;
        margin: 0 auto 80px auto;

        video {
            width: 1200px;
            height: 674px;
            border-radius: 30px;
            background-color: #000000;
        }
    }

    &-news {
        padding: 50px 0;
        background-color: #F8FAFC;

        &__news {
            width: 1200px;
            margin: 0 auto;

            &__title {
                font-family: PingFangSC-medium;
                color: #333333;
                font-weight: 500;
                font-size: 36px;
                letter-spacing: 2px;
                line-height: 56px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .page-btns {
                    img {
                        margin-left: 34px;
                        cursor: pointer;
                    }

                    img:hover {
                        opacity: .7;
                    }
                }
            }

            &__desc {
                color: #666666;
                font-weight: 400;
                font-size: 24px;
                letter-spacing: 2px;
                margin-top: 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .more {
                    color: #1753A3;
                    font-weight: 400;
                    font-size: 20px;
                    letter-spacing: 1px;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    line-height: 28px;

                    img {
                        margin-left: 8px;
                    }
                }

                .more:hover {
                    opacity: .7;
                }
            }

            &__grid {
                display: flex;
                justify-content: space-between;
                margin-top: 36px;
            }
        }
    }

    &-brands {
        margin: 50px auto;
        max-width: 1200px;

        .brand {
            margin-bottom: 44px;

            &-title {
                font-family: PingFangSC-medium;
                color: #333333;
                font-weight: 500;
                font-size: 36px;
                letter-spacing: 2px;
                line-height: 56px;
            }

            &-logo {
                display: flex;
                flex-wrap: wrap;

                &__item {
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        width: 1200px;
                    }
                }
            }
        }
    }
}




/* 响应式布局 */
@media (max-width: 768px) {
    .home {
        position: relative;

        &-banner {
            width: 100%;
            min-width: 100%;
            height: 234px;
            position: relative;
            z-index: -1;
        }

        &-countdown {
            margin: 0 auto;
            height: 90px;
            position: absolute;
            top: 132px;
            left: 50%;
            transform: translateX(-50%);

            .countdown {
                width: 320px;
                height: 90px;
                border-radius: 10px;

                &-time {
                    margin-top: -5px;

                    &__top {
                        font-size: 20px;
                        letter-spacing: 2px;
                        line-height: 22px;
                    }

                    &__bottom {
                        font-size: 12px;
                        margin-top: 2px;
                        line-height: 17px;
                        margin-bottom: 4px;
                        letter-spacing: 1px;
                    }
                }
            }
        }

        &-section {
            display: block;
            width: calc(100% - 24px);
            margin: 24px 12px;
        }

        &-video {
            width: 100%;
            height: 210px;
            margin: 0 auto 24px auto;

            video {
                width: calc(100% - 24px);
                height: 210px;
                margin: 0 12px;
                border-radius: 8px;
                
            }
        }

        &-news {
            padding: 24px 12px;

            &__news {
                max-width: 100%;
                margin: 0 auto;

                &__title {
                    font-family: PingFangSC-semibold;
                    font-weight: 600;
                    font-size: 18px;
                    letter-spacing: 0px;
                    line-height: 24px;

                    .page-btns {
                        img {
                            margin-left: 36px;
                            width: 24px;
                            height: 24px;
                        }
                    }
                }

                &__desc {
                    font-size: 14px;
                    letter-spacing: 1px;
                    margin-top: 8px;
                    line-height: 20px;

                    .more {
                        line-height: 17px;
                        font-size: 12px;

                        img {
                            margin-left: 6px;
                            width: 10px;
                            height: 10px;
                        }
                    }

                    .more:hover {
                        opacity: .7;
                    }
                }

                &__grid {
                    display: block;
                    margin-top: 0;
                }
            }
        }

        &-brands {
            margin: 0;
            padding: 24px 12px;

            .brand {
                margin-top: 12px;
                margin-bottom: 0;

                &-title {
                    font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                }

                &-logo {
                    &__item {
                        width: 100%;
                        margin: 6px;
                        overflow: hidden;

                        img {
                            width: 100%;
                        }
                    }
                }
            }
        }
    }
}
</style>